import { createReducer, on } from '@ngrx/store';

import { User } from '@core/api';

import { initActions } from '../actions/init.actions';
import { userApiActions } from '../actions/user.actions';

export const featureKey = 'user';

export type UserState = User | undefined;

export const initialState: UserState = undefined;

export const reducer = createReducer<UserState>(
  initialState,
  on(userApiActions.logoutSuccess, userApiActions.tokenExpired, userApiActions.tokenDeleted, () => initialState),

  on(initActions.appComplete, userApiActions.loginSuccess, userApiActions.fetchUserSuccess, (state, { user }) =>
    user ? { ...user } : undefined
  ),

  on(userApiActions.updateUserSuccess, (state, { user }) => (state ? { ...state, ...user } : state)),

  on(userApiActions.updateRegionConfig, (state, { regionConfig }) =>
    state
      ? {
          ...state,
          regionConfig: {
            ...regionConfig,
            defaultChanged: true,
          },
        }
      : state
  )
);
